/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Open_SidebarInputs */

const en_nav_app_open_sidebar = /** @type {(inputs: Nav_App_Open_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open sidebar`)
};

const es_nav_app_open_sidebar = /** @type {(inputs: Nav_App_Open_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir barra lateral`)
};

/**
* | output |
* | --- |
* | "Open sidebar" |
*
* @param {Nav_App_Open_SidebarInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_open_sidebar = /** @type {((inputs?: Nav_App_Open_SidebarInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Open_SidebarInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_open_sidebar(inputs)
	return en_nav_app_open_sidebar(inputs)
});